'use client'

import { DialogTitle } from '@headlessui/react'
import {
  SectionHeaderTitle,
  type SectionHeaderTitleProps,
} from '../../../headers/section-header/section-header-title.tsx'

export type ModalHeaderTitleProps = SectionHeaderTitleProps

export const ModalHeaderTitle = (props: ModalHeaderTitleProps) => {
  return <DialogTitle as={SectionHeaderTitle} {...props} />
}
